module.exports = __webpack_public_path__ + "static/img/Denis-Genreau.d1370ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Denis-Genreau.jpg
// module id = tm5y
// module chunks = 0